import classNames from 'classnames'
import React from 'react'

import { MobileAppPlatformIcon } from '@ui/icons/MobileAppPlatform.icon'

import { LuckyDraw, WheelRef } from '../../LuckyDraw'

import styles from '../LuckyDraw.modal.module.scss'

interface WheelSectionProps {
  isMobile: boolean
  sectors: any[]
  winner: number
  fortuneWheelRef: React.RefObject<WheelRef | null>
  setPlaying: (playing: boolean) => void
  setWon: (won: boolean) => void
  onSpinComplete: () => void
}

export const WheelSection: React.FC<WheelSectionProps> = ({
  isMobile,
  sectors,
  winner,
  fortuneWheelRef,
  setPlaying,
  setWon,
  onSpinComplete,
}) => {
  return (
    <section className={classNames(styles.wheelBox)}>
      <div className={styles.logoBox}>
        <MobileAppPlatformIcon size={isMobile ? 50 : 72} />
      </div>

      <LuckyDraw
        ref={fortuneWheelRef}
        winnerIndex={winner}
        sectors={sectors}
        setWon={() => {
          setPlaying(false)
          onSpinComplete()
          setWon(true)
        }}
      />
    </section>
  )
}
